import React from 'react';
import { Info } from 'lucide-react';
import type { CustomEmbedData } from './types';

interface CustomHtmlTabProps {
  data: CustomEmbedData;
  onChange: (field: string, value: string) => void;
}

export const CustomHtmlTab: React.FC<CustomHtmlTabProps> = ({ data, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start space-x-2">
          <Info size={20} className="text-blue-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Custom HTML Embed</p>
            <p>
              Paste any embed code here - YouTube, Vimeo, Google Maps, Twitter, Instagram, etc. Just
              paste the entire embed code and it will work!
            </p>
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Embed Code (HTML) *</label>
        <textarea
          value={data.html}
          onChange={e => onChange('html', e.target.value)}
          rows={10}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
          placeholder='<iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" frameborder="0" allowfullscreen></iframe>'
        />
        <p className="mt-2 text-sm text-gray-500">
          Paste the complete embed code including &lt;iframe&gt;, &lt;script&gt;, or other HTML
          tags.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Custom CSS (Optional)
        </label>
        <textarea
          value={data.css}
          onChange={e => onChange('css', e.target.value)}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
          placeholder=".my-embed { border-radius: 8px; }"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Custom JavaScript (Optional)
        </label>
        <textarea
          value={data.javascript}
          onChange={e => onChange('javascript', e.target.value)}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent font-mono text-sm"
          placeholder="// Custom JavaScript code"
        />
        <p className="mt-1 text-xs text-gray-500">Do not include &lt;script&gt; tags</p>
      </div>
    </div>
  );
};
